// components/Common/Spinner.js
import React from "react";
import { Spinner as ReactstrapSpinner } from "reactstrap";

const FullScreenSpinner = () => (
  <div
    className="d-flex justify-content-center align-items-center vh-100"
    style={{
      zIndex: 9999,
      backgroundColor: "#ffffff",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    }}
  >
    <ReactstrapSpinner color="primary" style={{ width: "3rem", height: "3rem" }} />
  </div>
);

export default FullScreenSpinner;
